/**
 * @generated SignedSource<<49f0fd0131d5b4304ff17bbf7c70a8b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type homeStoryPackageTailContentItemContent$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "homeStoryPackageTailContentItemContent";
};
export type homeStoryPackageTailContentItemContent$key = {
  readonly " $data"?: homeStoryPackageTailContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"homeStoryPackageTailContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "homeStoryPackageTailContentItemContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "547201564aac4b64d0b1bdd9eccc68d1";

export default node;
